import { Card as CardMUI, MenuItem as MenuItemMUI, MenuList as MenuListMUI } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from 'oems/theme';

import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';

export const Card = styled(CardMUI)`
  padding: 4rem 4rem;
`;

export const IconS = styled('img')`
  width: 14px;
  height: 14px;
  margin-right: 0.5rem;
  margin-bottom: 0rem;
  margin-top: 0rem;
`;

export const IconM = styled('img')`
  width: 18px;
  height: 18px;
  margin-right: 0.5rem;
  margin-bottom: 0rem;
  margin-top: 0rem;
`;

export const IconL = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  margin-bottom: 0;
  margin-top: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DeleteSelected = styled(DeleteSweepOutlinedIcon)`
  position: relative;
  left: -7px;
  width: 36px;
  height: 26px;
  color: ${(props) => props.theme.palette.error.main};
`;

export const DangerLabel = styled('span')`
  position: relative;
  left: -8px;
  text-transform: none;
  font-size: 14px;
  font-weight: 400;
  white-space: pre;
  color: ${theme.palette.error.main};
  text-align: left;
`;

export const MenuList = styled(MenuListMUI)`
  width: 100%;
  flex-direction: column;
  display: flex;
`;

export const EditMenuItem = styled(MenuItemMUI)``;
